<!-- 表二列表 -->

<template>
  <div class="ListCage table5">
    <div class="tabTtl">
      <span>表 1-5：获得表彰情况登记表</span>
      <div class="tabBtns">
        <el-button type="primary" @click="memberEdit(1)" size="mini">添加</el-button>
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <div class="ctrlsLine">
      <el-input v-model="seekPms.keyword" size="small" placeholder="通过奖项名称、颁奖单位查询"></el-input>
      <el-button class="seekBtn" @click="tabSeek('init')" size="small">查询</el-button>
      <el-button class="dangerBtns" size="small" @click="memberDet(1)" type="warning">删除</el-button>
      <el-button class="dangerBtns" @click="memberClean" size="small" type="danger">清除全部</el-button>
    </div>
    <div class="tabArea">
      <!-- :data="filterData(tabDat, seekPms).slice((currentPage - 1) * pageSize, currentPage * pageSize)" -->
      <el-table
        :data="filterData(tabDat, seekPms)"
        border
        style="width: 100%"
        @selection-change="selectionChange"
        v-loading="loading">
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + 1 + 15 * (seekPms.no - 1) }}
          </template>
        </el-table-column>
        <el-table-column prop="hjName" label="奖项名称" align="center"> </el-table-column>
        <el-table-column label="表彰对象" align="center">
          <template slot-scope="scope">
            {{ scope.row.bzObject | translate("C023", dicMap, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="commend" label="奖励内容" align="center"> </el-table-column>
        <el-table-column prop="bjName" label="颁奖单位" align="center"> </el-table-column>
        <el-table-column label="获奖级别" align="center">
          <template slot-scope="scope">
            {{ scope.row.hjLevel | translate("C024", dicMap, scope.row) }}
          </template>
        </el-table-column>
        <el-table-column label="表彰时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.hjDate }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="memberEdit(2, scope.row)" size="mini">编辑</el-button>
            <el-button type="danger" @click="memberDet(2, scope.row)" size="mini">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="headBar">
      <span>申报人信息</span>
    </div>
    <div class="editArea newEditArea">
      <div class="editBox">
        <p class="edName">申报人：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">联系方式：</p>
        <div class="edInp">
          <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
        </div>
      </div>
      <div class="editBox">
        <p class="edName">申报时间：</p>
        <div class="edInp">
          <el-input size="small" v-model="updatedAt" :disabled="true"></el-input>
        </div>
      </div>
      <div class="saveBtn">
        <el-button size="small" @click="goBack">返回</el-button>
        <el-button v-if="pubStatus == 0" type="primary" size="small" @click="postDeclareFun">保存</el-button>
      </div>
    </div>
    <div class="pageArea">
      <el-pagination
        v-if="allPage > 1"
        layout="prev, pager, next"
        @current-change="goPage"
        :current-page="seekPms.no"
        :page-count="allPage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import initPagin from "@/mixins/initPagin";
import { tabList5, tab5Remove, tab5Clean, submitDeclare } from "@/api/pressRole/pressRole";
export default {
  mixins: [initPagin],
  data() {
    return {
      loading: false,
      tabDat: [],
      detArrs: [],
      dicMap: {},
      yearSet: 0,
      seekPms: {
        keyword: "",
        no: 1,
        size: 15,
      },
      declare: {
        personnel: "",
        contact: "",
      },
      updatedAt: "",
      pubStatus: 0,
    };
  },
  filters: {
    translate: function (dat, code, transMap, rowdat) {
      if (code == "C024" && transMap[code][dat] == "其他") {
        return rowdat.hjLevelOther;
      } else {
        return transMap[code][dat];
      }
    },
    stringTrans: function (dat, code) {
      if (code == "time") {
        return dat.substr(0, 10);
      }
    },
  },
  methods: {
    tabSeek: function (type) {
      this.loading = true;
      if (type == "init") {
        this.seekPms.no = 1;
      }

      tabList5(this.seekPms).then((response) => {
        let vm = this;
        setTimeout(function () {
          vm.tabDat = response.pCommendList;
          vm.loading = false;
          vm.allPage = response.totalPages;
        }, 300);
        if (response.pOrganizationPersonnel !== null) {
          this.declare.contact = response.pOrganizationPersonnel.contact;
          this.declare.personnel = response.pOrganizationPersonnel.personnel;
          this.updatedAt = response.pOrganizationPersonnel.updatedAt;
        }
      });
    },
    memberDet: function (type, dat) {
      let params = {};
      let message = "";

      if (type == 1) {
        params.ids = this.detArrs;
        message = "确认删除所有选中项吗？";
      } else if (type == 2) {
        params.ids = [dat.id];
        message = "确定删除吗？";
      }

      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        params.publishMaterialId = this.$route.query.mtId;

        if (params.ids.length == 0) {
          this.$message.error("请勾选所想要删除的项！");
        } else {
          tab5Remove(params)
            .then((response) => {
              this.tabSeek();
            })
            .catch((error) => {});
        }
      });
    },
    memberClean: function () {
      this.$confirm("此操将永久删除全部信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          tab5Clean({
            publishMaterialId: this.$route.query.mtId,
          }).then((response) => {
            this.tabSeek();
          });
        })
        .catch(() => {});
    },
    selectionChange: function (selection) {
      let newArr = [];
      for (let i = 0; i < selection.length; i++) {
        newArr.push(selection[i].id);
      }
      this.detArrs = newArr;
    },
    dictInit: function () {
      let nameArr = ["C023", "C024"];
      let newPromise = this.$store.dispatch("dictUpdate", {
        codeArr: nameArr,
        type: "map",
      });
      newPromise.then((result) => {
        this.dicMap = result;
        this.tabSeek();
      });
    },
    memberEdit: function (type, dat) {
      let pathParams = {
        pressId: this.$route.query.pressId,
        mtId: this.$route.query.mtId,
        pressType: this.$route.query.pressType,
        pgress: type,
        pubStatus: this.pubStatus,
      };

      if (dat) {
        pathParams.id = dat.id;
      }

      this.$router.push({
        path: "edit_tab5",
        query: pathParams,
      });
    },

    goPage: function (inx) {
      this.seekPms.no = inx;
      this.tabSeek();
    },

    goBack: function () {
      this.$router.go(-1);
    },
    /*
     *提交申报人信息
     * */
    postDeclareFun: function () {
      let that = this;
      if (!this.declare.personnel) {
        this.$message.error("申报人姓名必填");
        return;
      }
      // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
      //   this.$message.error('申报人手机号格式错误');
      //   return
      // }
      if (!this.declare.contact) {
        this.$message.error("申报人联系方式必填");
        return;
      }
      submitDeclare({
        // hsj.手动加code，统一模组化
        code: "205",
        publishMaterialId: this.$route.query.mtId,
        organizationPersonnel: this.declare,
      })
        .then((response) => {
          let tipCode = response.payload.code;
          let tipMessage = response.payload.message;

          that.submiting = false;
          if (tipCode == -1) {
            that.$message.error(`保存错误: ${tipMessage}`);
            return;
          }

          that.$message({
            message: "保存成功！",
            type: "success",
          });

          that.goBack();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filterData: function (data, params) {
      console.debug("filterData: ", params.type, params.keyword);
      let text = params.keyword;
      // if (!text || text.trim() === '') return data
      text = text.toLowerCase();
      return _.filter(data, (x) => {
        // if (params.type !=0 && x.type != params.type) return false
        return (x.hjName && x.hjName.includes(text)) || (x.bjName && x.bjName.includes(text));
      });
    },
  },
  created: function () {
    this.seekPms.publishMaterialId = this.$route.query.mtId;
    this.dictInit();
    this.pubStatus = this.$route.query.pubStatus;
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleL";

.table5 .pageArea {
  text-align: center;
  padding: 30px 0px;
}

.table5 {
  .saveBtn {
    margin: 30px 200px;

    .el-button {
      width: 150px;
      margin-right: 10px;
    }
  }

  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// table5.vue?a102f0fe